import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const ProviderContextSwitcher = ({
  selectedProvider = 'main-provider',
  onChange,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [providerOptions, setProviderOptions] = useState([]);

  // Mock data (fallback)
  const mockProviderOptions = [
    {
      value: 'main-provider',
      label: 'خدمات دهنده اصلی',
      address: 'تهران، خیابان ولیعصر',
      status: 'active',
      employeeCount: 8,
    },
    {
      value: 'branch-1',
      label: 'شعبه شمال',
      address: 'تهران، خیابان شریعتی',
      status: 'active',
      employeeCount: 5,
    },
    {
      value: 'branch-2',
      label: 'شعبه غرب',
      address: 'تهران، خیابان ستاری',
      status: 'maintenance',
      employeeCount: 6,
    },
  ];

  // Load Providers from localStorage
  useEffect(() => {
    const storedProviders = localStorage.getItem('@providers');
    if (storedProviders) {
      try {
        setProviderOptions(JSON.parse(storedProviders));
      } catch (err) {
        console.error('Error parsing Providers from localStorage', err);
        setProviderOptions(mockProviderOptions);
      }
    } else {
      setProviderOptions(mockProviderOptions);
    }
  }, []);

  const selectedProviderData = providerOptions?.find(
    (provider) => provider?.value === selectedProvider
  );

  const handleProviderSelect = (providerValue) => {
    onProviderChange?.(providerValue);
    setIsOpen(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success';
      case 'maintenance':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return 'فعال';
      case 'maintenance':
        return 'تعمیرات';
      default:
        return 'نامشخص';
    }
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-3 bg-muted border border-border rounded-lg text-right hover:bg-muted/80 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-sm font-medium text-foreground">
                {selectedProviderData?.label}
              </h3>
              <span
                className={`text-xs ${getStatusColor(
                  selectedProviderData?.status
                )}`}>
                ● {getStatusLabel(selectedProviderData?.status)}
              </span>
            </div>
            <p className="text-xs text-muted-foreground">
              {selectedProviderData?.address}
            </p>
            <div className="flex items-center gap-4 mt-1">
              <span className="text-xs text-muted-foreground">
                {selectedProviderData?.employeeCount} کارمند
              </span>
            </div>
          </div>
          <Icon
            name="ChevronDown"
            size={16}
            className={`text-muted-foreground transition-transform duration-150 ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </div>
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-popover border border-border rounded-lg shadow-elevation-3 z-dropdown animate-fade-in">
          <div className="py-2">
            {providerOptions?.map((provider) => (
              <button
                key={provider?.value}
                onClick={() => handleProviderSelect(provider?.value)}
                className={`
                  w-full px-4 py-3 text-right hover:bg-muted transition-colors duration-150
                  ${provider?.value === selectedProvider ? 'bg-primary/10' : ''}
                `}>
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="text-sm font-medium text-foreground">
                        {provider?.label}
                      </h4>
                      <span
                        className={`text-xs ${getStatusColor(
                          provider?.status
                        )}`}>
                        ● {getStatusLabel(provider?.status)}
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground mb-1">
                      {provider?.address}
                    </p>
                    <span className="text-xs text-muted-foreground">
                      {provider?.employeeCount} کارمند
                    </span>
                  </div>
                  {provider?.value === selectedProvider && (
                    <Icon name="Check" size={16} className="text-primary" />
                  )}
                </div>
              </button>
            ))}
          </div>

          <div className="border-t border-border pt-2">
            <button
              // disabled
              onClick={() => setIsOpen(false)}
              className="w-full px-4 py-2 text-right text-sm text-primary hover:bg-muted transition-colors duration-150 flex items-center gap-2">
              <Icon name="Plus" size={16} />
              افزودن خدمات دهنده جدید
            </button>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-[250]"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ProviderContextSwitcher;
